"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ApiClientUncaughtError extends Error {
    // tslint:disable-next-line:no-any
    constructor(message, error) {
        super(message) /* istanbul ignore next */;
        this.name = 'ApiClientUncaughtError';
        this.error = error;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.ApiClientUncaughtError = ApiClientUncaughtError;
